(() => {
  const init = (root) => {
    if (root.dataset.rzPartnerReady) return;
    root.dataset.rzPartnerReady = 'true';
    const tabs = [...root.querySelectorAll('[data-creator-tab]')];
    const orderedTabs = [...tabs].sort((a, b) => Number(a.dataset.creatorOrder) - Number(b.dataset.creatorOrder));
    const panels = [...root.querySelectorAll('[data-creator-panel]')];
    if (!tabs.length) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let changeTimer;
    let enterTimer;

    const show = (slug, updateUrl = false, animate = false) => {
      if (!tabs.some(tab => tab.dataset.creatorTab === slug)) slug = tabs[0].dataset.creatorTab;
      clearTimeout(changeTimer);
      clearTimeout(enterTimer);
      const current = panels.find(panel => !panel.hidden);
      const next = panels.find(panel => panel.dataset.creatorPanel === slug);
      panels.forEach(panel => panel.classList.remove('is-leaving', 'is-entering'));
      tabs.forEach(tab => {
        const active = tab.dataset.creatorTab === slug;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('creator', slug);
        history.pushState({ creator: slug }, '', url);
      }
      const commit = () => {
        panels.forEach(panel => {
          const active = panel === next;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.classList.remove('is-leaving', 'is-entering');
        });
        if (animate && !reducedMotion.matches && current !== next) {
          next.classList.add('is-entering');
          enterTimer = setTimeout(() => next.classList.remove('is-entering'), 440);
        }
      };
      if (animate && !reducedMotion.matches && current && current !== next) {
        current.classList.add('is-leaving');
        changeTimer = setTimeout(commit, 180);
      } else {
        commit();
      }
    };

    const fromUrl = () => show(new URLSearchParams(location.search).get('creator'));
    root.addEventListener('click', async event => {
      const tab = event.target.closest('[data-creator-tab]');
      if (tab && root.contains(tab)) {
        event.preventDefault();
        show(tab.dataset.creatorTab, true, true);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const button = event.target.closest('[data-rz-set-add]');
      if (!button || !root.contains(button) || button.disabled) return;
      const message = button.parentElement.querySelector('.rz-partner__set-message');
      button.disabled = true;
      message.textContent = 'Wird hinzugefügt …';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(button.dataset.padId), quantity: 1 },
            { id: Number(button.dataset.sleeveId), quantity: 1 }
          ] })
        });
        if (!response.ok) throw new Error('add failed');
        message.textContent = 'Beide Produkte sind im Warenkorb.';
        window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (_) {
        message.textContent = 'Das Set konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
        button.disabled = false;
      }
    });
    root.addEventListener('keydown', event => {
      const tab = event.target.closest('[data-creator-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const index = orderedTabs.indexOf(tab);
      const next = orderedTabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + orderedTabs.length) % orderedTabs.length];
      show(next.dataset.creatorTab, true, true);
      next.focus();
    });
    window.addEventListener('popstate', fromUrl);
    fromUrl();
  };

  document.querySelectorAll('[data-rz-partner]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rz-partner]').forEach(init));
})();
